import React from 'react';
import './Ticker.css';

const words = [
  'ANDRXW', '//', 'PRODUCER', '//', 'ARTIST', '//',
  'ROMANIA', '//', 'OPEN FOR COLLABS', '//',
];

const Ticker: React.FC = () => {
  // Duplicate for seamless loop
  const items = [...words, ...words];

  return (
    <div className="ticker-wrap">
      <div className="ticker-track">
        {items.map((word, i) => (
          <span key={i}>{word}</span>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
